import { IconButton } from '@mui/material';
import VisibilityOutlined from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlined from '@mui/icons-material/VisibilityOffOutlined';
import { AUTH_TOKENS } from './auth-branding';

interface PasswordAdornmentProps {
  visible: boolean;
  onToggle: () => void;
}

/** Show/hide toggle to pass as an AuthField endAdornment for password fields. */
export const PasswordAdornment = ({ visible, onToggle }: PasswordAdornmentProps) => (
  <IconButton
    onClick={onToggle}
    edge="end"
    disableRipple
    aria-label={visible ? 'Hide password' : 'Show password'}
    sx={{ color: AUTH_TOKENS.inkTertiary }}
  >
    {visible ? <VisibilityOffOutlined sx={{ fontSize: 20 }} /> : <VisibilityOutlined sx={{ fontSize: 20 }} />}
  </IconButton>
);
